import { Backdrop, CircularProgress, Container, Grid, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import TextField from '../../components/Form/TextField';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { ASN } from '../../interfaces/Asn';
import AsnStatus from '../../interfaces/AsnStatus';
import AsnApi from '../../services/AsnApi';
import getDefaultGridOptions, { DataFormat } from '../../utils/componentUtils';
import utilsDate from '../../utils/Date';
import ASNInvoiceList from './ASNInvoiceList';
import { useStyles } from './Style';

interface Params {
    asnId?: string;
}

const ViewASN: React.FC = () => {
    const params = useParams<Params>()
    const classes = useStyles();
    const [asns, setAsns] = useState<any>();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("ASN");
    const { t: tval } = useTranslation("Validation");
    const history = useHistory();
    const [circularLoading, setCircularLoading] = useState(true)
    const [asnLogs,setAsnLogs] = React.useState<any[]>();
    const [asn,setAsn] = React.useState<any>();

    useEffect(() => {

        const getMvm = async () => {


            if(params.asnId != null && params.asnId != "")
            {
                var asn : ASN = (await AsnApi.search({AsnId : +params.asnId!, pageIndex:0, pageSize:10})).items[0];

                reset({
                    asnNumber: asn.asnNumber,
                    supplier: 
                        asn.shippingCompanySupplierId + "- " + asn.shippingCompanySupplierCorporateName,                       
                    originSupplier:
                        asn.originSupplierId + " - " + asn.originSupplierCorporateName,
                    destinySupplier: asn.destinationSupplierId + " - " + asn.destinationSupplierCorporateName,

                    //todo
                    vehicleType: `${asn.vehicleType}-${asn.vehicleDescription}`,


                    motorVehiclePlateNumber: asn.vehiclePlateNumber,
                    vehicleBrand: asn.vehicleBrandDescription,
                    cartPlateNumber: asn.cartPlateNumber,
                    //todo               
                    vehicleType2: `${asn.vehicleType2 != null && asn.vehicleType2 != '' ? asn.vehicleType2 + '-' + asn.vehicleDescription2 : ''}`,
                    vehiclePlateNumber2: asn.vehiclePlateNumber2,
                    //todo
                    vehicleType3: `${asn.vehicleType3 != null && asn.vehicleType3 != '' ? asn.vehicleType3 + '-' + asn.vehicleDescription3 : ''}`,
                    vehiclePlateNumber3: asn.vehiclePlateNumber3,
                    knowledgeNumber: asn.cteNumber,
                    salesInvoices: asn.invoices,
                    asnStatusDescription: asn.asnStatusDescription,
                    createdBy: asn.createdBy,
                    submitDate: utilsDate.DateTime(asn.submitDate),
                    submitUser: asn.submitUser,
                    receiptDate: utilsDate.DateTime(asn.receiptDate),
                    receiptUser: asn.receiptUser,
                    cancelDate: utilsDate.DateTime(asn.cancelDate),
                    cancelUser: asn.cancelUser,
                    updatedAt: utilsDate.DateTime(asn.updatedAt),
                    updatedBy: asn.updatedBy
                });  
                
                setAsnLogs(asn.logs);  
                setAsn(asn);        
            }

            setCircularLoading(false);
        };

        getMvm();       

    

    }, []);

    const { handleSubmit, reset, control, getValues, setError, resetField, setValue, setFocus, clearErrors } = useForm<any>({
        defaultValues: {
            supplier: "",
            originSupplier: "",
            destinySupplier:  "",
            vehicleType:  "",
            vehicleType2:  "",
            vehicleType3:  ""
        }
    });

    const yupValidationOnSubmit = async () => {        

        var data = getValues();
        clearErrors(["originSupplier"])
        clearErrors(["destinySupplier"])
        clearErrors(["supplier"])
        clearErrors(["vehicleBrand"])
        clearErrors(["cartPlatNumber"])

        try {
            const schema = Yup.object().shape({
                originSupplier: Yup.object().nullable()
                    .required(tval("requiredField")),
                destinySupplier: Yup.object().nullable()
                    .required(tval("requiredField")),
                supplier: Yup.object().nullable()
                    .required(tval("requiredField")),
                vehicleBrand: Yup.object().nullable()
                    .required(tval("requiredField")),
                cartPlatNumber: Yup.object().nullable()
                    .required(tval("requiredField")),
            })
            await schema.validate(data, {
                abortEarly: false,
            })

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    setError(error.path?.split('.')[0] as "RackTypeCode" | "SupplierCode", { message: error.message })
                })
            }

            return false
        }
        return true
    }


    const cleanFilters = () => {
        reset({
            supplier: {},
            vehiclePlateNumber: '',
            cartPlateNumber: '',
            flagEuroClassification: ''
        });
    };

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: asns ? 'pointer' : ''
                }
            }
        }
    })
    
    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'logTypeDescription',
            label: _t("logType"),
            options: {
                setCellProps: () => ({
                    align: "left",
                }),
            }
        },
        {
            name: 'logDate',
            label: _t("dateTime"),

            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: DataFormat
            }
        },
        {
            name: 'createdBy',
            label: _t("createdBy"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        }
    ];

    return (
        <Container maxWidth={false} component="main">

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <PageTitle title={t("viewASN")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={() => {}}  >                       

                        <Grid container spacing={2} style={{paddingRight:"10px"}}>
                            <Grid item xs={4} >
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("origin")} name="originSupplier" control={control} fullWidth />

                            </Grid>

                            <Grid item xs={4} >
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("destiny")} name="destinySupplier" control={control} fullWidth />

                            </Grid>

                            <Grid item xs={4} >
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("ShippingCompany")} name="supplier" control={control} fullWidth />
                            </Grid>

                        </Grid>

                        {asn != null && asn.asnStatus != AsnStatus.FLAG_STATUS_DRAFT ? 
                            <>
                                <Grid container spacing={1} style={{height:"50px"}}>
                                </Grid>
                                <Typography className={classes.root} style={{ marginLeft: 0 }} >
                                    {t("generalInformation")}
                                </Typography>
                                <Grid container spacing={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("code")} name="asnNumber" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("state")} name="asnStatusDescription" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={_t("createdBy")} name="createdBy" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("issueDate")} name="submitDate" control={control} fullWidth />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("issuedBy")}name="submitUser" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("receivedAt")} name="receiptDate" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("receivedBy")} name="receiptUser" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("canceledAt")} name="cancelDate" control={control} fullWidth />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("canceledBy")} name="cancelUser" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={_t("updatedAt")} name="updatedAt" control={control} fullWidth />
                                        </Grid>
                                        <Grid item xs={3} >
                                            <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={_t("updatedBy")} name="updatedBy" control={control} fullWidth />
                                        </Grid>
                                    </Grid>
                                </Grid> 
                            </> :
                            <></>
                    }       

                        <Grid container spacing={1} style={{height:"50px"}}>
                        </Grid>
                        <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("mainVehicle")} name="vehicleType" control={control} fullWidth />

                            </Grid>

                            <Grid item xs={2}>
                                    <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("motorVehiclePlate")} name="motorVehiclePlateNumber" control={control} fullWidth />
                                
                            </Grid>

                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("vehicleBrand")} name="vehicleBrand" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("cartPlateNumber")} name="cartPlateNumber" control={control} fullWidth />
                            </Grid>
                        </Grid>   

                         <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t('vehicleType') + " 2:"} name="vehicleType2" control={control} fullWidth />

                            </Grid>

                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("vehiclePlateNumber")} name="vehiclePlateNumber2" control={control} fullWidth />
                            </Grid>
                        </Grid>    

                        <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                    <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t('vehicleType') + " 3:"} name="vehicleType3" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("vehiclePlateNumber")} name="vehiclePlateNumber3" control={control} fullWidth />
                            </Grid>
                        </Grid>    

                        <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} InputProps={{readOnly: true}} label={t("knowledgeNumber")} name="knowledgeNumber" control={control} fullWidth />
                            </Grid>
                        </Grid>   

                        <Grid container spacing={1} style={{height:"30px"}}>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <ASNInvoiceList
                                    control={control}
                                    title={t("salesInvoices")}
                                    name={"salesInvoices"}
                                    showItens={true}
                                    allowAdd={false}
                                    allowDelete={false}
                                    Mvm={null}/>
                            </Grid>
                        </Grid> 

                        <Grid container spacing={1} style={{height:"30px"}}>
                        </Grid>

                        <Grid container spacing={2} style={{height:"30px"}}>
                            <Grid item xs={12} style={{marginBottom:"30px"}}>
                                <Typography className={classes.root} style={{ marginLeft: 0 }} >
                                {t("asnLogs")}
                                </Typography>
                                <Typography className={classes.paper} style={{ marginLeft: 0 }} >
                                    {_t("totalRecords")} {asnLogs ? asnLogs.length : '0'}
                                </Typography>
                                <MuiThemeProvider theme={myTheme} >
                                    <MUIDataTable
                                        title=""
                                        data={asnLogs??[]}
                                        columns={columns}
                                        options={{
                                            ...getDefaultGridOptions(_t),
                                            serverSide: false,
                                            pagination: false,
                                            sort: false,
                                            selectToolbarPlacement: "none",
                                            filter: false,
                                            search: false,
                                            download: false,
                                            print: false,
                                            viewColumns: false,
                                            selectableRows: 'none',
                                        }}
                                    />
                                </MuiThemeProvider>
                            </Grid>

                            <Grid container spacing={1}>
                                <ButtonUI onClick={() => {history.replace('/ASN')} } color="secondary">{_t("back")}</ButtonUI>
                            </Grid>      
                        </Grid>
                        
                    </form>
                </div>
            </div>
            
        </Container>
    )
}
export default ViewASN;